import React from 'react';
import { SupDisclaimer } from '@vw-marketing/us-components';

import { styled } from '@vw-marketing/us-components';
import { useDisclaimerContext } from '../../context/DisclaimerContext';

interface ClickableSupDisclaimerProps {
  children: React.ReactNode;
  disclaimerNumber?: string;
}

const ClickableWrapper = styled.span`
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const ClickableSupDisclaimer: React.FC<ClickableSupDisclaimerProps> = ({ 
  children, 
  disclaimerNumber = '1' 
}) => {
  const { showDisclaimer } = useDisclaimerContext();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    showDisclaimer(disclaimerNumber);
  };

  return (
    <ClickableWrapper onClick={handleClick}>
      {/*@ts-ignore */}
      <SupDisclaimer>{children}</SupDisclaimer>
    </ClickableWrapper>
  );
};